import classNames from 'classnames';
import React, { useMemo, useEffect, useState } from 'react';
import Flyout from './Flyout';
import { MenuTarget, virtualReference, targetFromEvent } from './Menu';
import { PortalPopper } from './PortalPopper';
import './TitleTag.scss';

type Props = React.HTMLAttributes<HTMLDivElement> & ({
  className?: string
  target?: MenuTarget
  targetRef?: HTMLDivElement | null,
})

export default function TitleTag({ className, children, targetRef }: Props) {
  const [target, setTarget] = useState<MenuTarget>()
  const [open, setOpen] = useState(false)
  const element = targetRef

  useEffect(() => {
    if (!targetRef) return

    const div = targetRef
    const handleMouseEnter = (e: MouseEvent) => {
      setTarget(undefined)
      setOpen(false)
    };
    if (div)
      div.addEventListener('mouseleave', handleMouseEnter)

    return () => {
      if (div)
        div.removeEventListener('mouseleave', handleMouseEnter)
    }
  }, [element, targetRef])

  useEffect(() => {
    if (!targetRef) return

    const div = targetRef
    let timer: NodeJS.Timeout
    const handleMouseLeave = (e: MouseEvent) => {
      setTarget(targetFromEvent(e))
      timer = setTimeout(function () {
        setOpen(true)
      }, 1000)
    };

    if (div)
      div.addEventListener('mouseenter', handleMouseLeave)

    return () => {
      if (div)
        div.removeEventListener('mouseenter', handleMouseLeave)

      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [element, targetRef])


  const visRef = useMemo(() => target && ('getBoundingClientRect' in target ? target : virtualReference(target)), [target])

  if (!open || !element) return null

  return <PortalPopper referenceElement={visRef || undefined} placement={'bottom-start'}>
    {({ ref, style }) => <Flyout className={classNames('TitleTag', className)} innerRef={ref} style={style}>
      {children}
    </Flyout>}
  </PortalPopper>
}
